// export const API_BASE_URL = "http://localhost:3010"; // Update with your backend URL
export const API_BASE_URL = "https://media.signalwerk.ch";
